export default __webpack_public_path__ + "static/media/salary-cap-logo.96efb4e9.png";